import { Box, SxProps } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Visa from 'assets/visa.svg?react';
import MasterCard from 'assets/mastercard.svg?react';
import Discover from 'assets/discover.svg?react';
import Amex from 'assets/amex.svg?react';
import PayPal from 'assets/paypal.svg?react';
import PayPalLogo from 'assets/paypal_logo.svg?react';
import ApplePay from 'assets/applepay.svg?react';
import { getResponsiveFontSize } from 'theme/watchdutyTheme.utils';
import { CardType } from 'shared/types';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';

type PaymentMethodProps = {
  type: CardType;
  sx?: SxProps;
};

type PaymentIconConfig = {
  Icon: ElementType;
  label: string;
};

const creditCardComponent: Record<CardType, PaymentIconConfig> = {
  Visa: { Icon: Visa, label: 'Visa' },
  MasterCard: { Icon: MasterCard, label: 'MasterCard' },
  Discover: { Icon: Discover, label: 'Discover' },
  Amex: { Icon: Amex, label: 'American Express' },
  'American Express': { Icon: Amex, label: 'American Express' },
  PayPal: { Icon: PayPal, label: 'PayPal' },
  PayPalLogo: { Icon: PayPalLogo, label: 'PayPal' },
  ApplePay: { Icon: ApplePay, label: 'Apple Pay' },
};

export const PaymentMethod = (props: PaymentMethodProps): JSX.Element => {
  const { type, sx } = props;
  const { t } = useTranslation();

  const config = creditCardComponent[type];

  if (!config) {
    return (
      <Box sx={{ ...sx, mt: -1 }}>
        <CreditCardIcon
          role="img"
          aria-label={t('recurlySavedPayment.paymentMethod.creditCard')}
          style={{ fontSize: getResponsiveFontSize('3.5rem') }}
        />
      </Box>
    );
  }

  const { Icon, label } = config;

  return (
    <Box sx={sx}>
      <Icon role="img" aria-label={label} />
    </Box>
  );
};
